function replaceUrl() {
  const currentUrl = new URL(window.location.href);
  const configValue = currentUrl.searchParams.get('config');
  const svValue = currentUrl.searchParams.get('sv');

  if (configValue) {
    currentUrl.searchParams.set('pcfg', configValue);
    window.history.replaceState({}, '', currentUrl);
  } else {
    return;
  }

  if (svValue) {
    currentUrl.searchParams.set('fscfg', `${svValue}`);
    window.history.replaceState({}, '', currentUrl);
  }
}

export default replaceUrl;
